import { computed } from '@ember/object';
import { dasherize } from '@ember/string';
import HtmlEscaper from '@intercom/embercom-composer/lib/html-escaper';
const slice = Array.prototype.slice;
function _isObject(param) {
  return typeof param === 'object';
}
let icBlockOpeningTag = function () {
  let params = slice.call(arguments);
  let finalParam = params[params.length - 1];
  params.splice(0, 0, 'type');
  params.splice(0, 0, 'generatedAt');
  let func = function () {
    let tag = `<ic-block data-generated-at="${this.get('generatedAt')}"`;
    let self = this;
    params.forEach(function (key) {
      let value = self.get(key);
      if (value) {
        let escapedValue = HtmlEscaper.escape(self.get(key));
        tag += ` data-${dasherize(key)}="${escapedValue}"`;
      }
    });
    tag += '>';
    return tag;
  };
  if (_isObject(finalParam)) {
    params.pop();
  }
  return computed.apply(this, params.concat([func]));
};
export default icBlockOpeningTag;